import { Navigate, RouteObject } from "react-router";
import { CalculationRoute } from "@/routes/processes/[processId]/vbs/calculations/[calculationId]/calculation-route";
import { CalculationTreatmentRoute } from "@/routes/processes/[processId]/vbs/calculations/[calculationId]/treatment/treatment-route";
import { CalculationCalculationRoute } from "@/routes/processes/[processId]/vbs/calculations/[calculationId]/calculation/calculation-route";
import { TextblocksRoute } from "./[calculationId]/textblocks/textblocks-route";
import { CalculationsRoute } from "./calculations-route";

export const calculationsRoutes: RouteObject[] = [
  {
    index: true,
    element: <CalculationsRoute />,
  },
  {
    path: ":calculationId",
    element: <CalculationRoute />,
    children: [
      {
        index: true,
        element: <Navigate to="treatment" replace />,
      },
      {
        path: "treatment",
        element: <CalculationTreatmentRoute />,
      },
      {
        path: "calculation",
        element: <CalculationCalculationRoute />,
      },
      {
        path: "textblocks",
        element: <TextblocksRoute />,
      },
    ],
  },
];
